import React, { useState } from 'react';
import video1 from '../assets/videos/videos1.mp4';
import video2 from '../assets/videos/videos2.mp4';
import video3 from '../assets/videos/videos3.mp4';

function OrganicJourney() {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const videoCards = [
    {
      src: video1,
      title: "Organic Farming",
      desc: "Real natural farming process from our organic fields."
    },
    {
      src: video2,
      title: "Fresh Harvest",
      desc: "Daily fresh harvesting directly from healthy organic soil."
    },
    {
      src: video3,
      title: "Farm Environment",
      desc: "Experience our clean and natural ecosystem."
    }
  ];

  return (
    <section style={{
      backgroundColor: '#f8fafc', // Light premium background to make dark videos pop
      padding: '100px 20px',
      fontFamily: 'system-ui, sans-serif',
      overflow: 'hidden'
    }}>
      
      {/* SECTION HEADER */}
      <div style={{ textAlign: 'center', marginBottom: '80px' }}>
        <p style={{ color: '#16803d', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '2px', fontSize: '13px', marginBottom: '12px' }}>
          OUR WORK IN ACTION
        </p>
        <h2 style={{ fontSize: '40px', color: '#1e293b', margin: '0 0 16px 0', fontWeight: '800', letterSpacing: '-1px' }}>
          Experience Our Real Organic Farms
        </h2>
        <p style={{ color: '#64748b', maxWidth: '600px', margin: '0 auto', lineHeight: '1.7', fontSize: '16px' }}>
          Watch our real farming process, harvesting, and healthy organic environment directly from AGP India Organic farms.
        </p>
      </div>

      {/* FIXED VIEWPORT LAYER FOR STACKED ELEMENTS */}
      <div style={{
        maxWidth: '1100px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '40px', // Creates the overlap spacing
        position: 'relative',
        height: '450px'
      }}>
        {videoCards.map((card, index) => {
          const isHovered = hoveredIndex === index;
          const anyHovered = hoveredIndex !== null;

          // Custom 3D stacking math based on positions
          let rotation = -5; // Default fan angle left
          if (index === 1) rotation = 0; // Middle straight
          if (index === 2) rotation = 5; // Right fan angle

          return (
            <div
              key={index}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              style={{
                width: '340px',
                backgroundColor: '#ffffff',
                borderRadius: '24px',
                overflow: 'hidden',
                boxShadow: isHovered 
                  ? '0 30px 60px rgba(15,23,42,0.25)' 
                  : '0 10px 25px rgba(15,23,42,0.06)',
                
                // Pure 3D Transform Lift Matrix
                transform: isHovered
                  ? 'translateY(-30px) scale(1.08) rotate(0deg)'
                  : `translateY(0px) scale(${anyHovered ? 0.92 : 1}) rotate(${rotation}deg)`,
                
                // Soft focus blur for elements not currently in view
                filter: anyHovered && !isHovered ? 'blur(1px) grayscale(20%)' : 'none',
                opacity: anyHovered && !isHovered ? 0.6 : 1,
                
                zIndex: isHovered ? 10 : index,
                transition: 'all 0.5s cubic-bezier(0.25, 1, 0.5, 1)', // Smooth organic snap spring
                cursor: 'pointer',
                position: 'relative'
              }}
            >
              {/* VIDEO EMBED CONTAINER */}
              <div style={{ width: '100%', height: '240px', position: 'relative', backgroundColor: '#000' }}>
                <video 
                  src={card.src} 
                  autoPlay
                  loop 
                  muted 
                  playsInline 
                  style={{ 
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover'
                  }}
                />
                
                {/* Clean floating tag indicating it's active */}
                {isHovered && (
                  <span style={{
                    position: 'absolute',
                    top: '16px',
                    left: '16px',
                    backgroundColor: 'rgba(22, 128, 61, 0.9)',
                    color: '#fff',
                    padding: '6px 14px',
                    borderRadius: '30px',
                    fontSize: '11px',
                    fontWeight: '700',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
                  }}>
                    Live Feed
                  </span>
                )}
              </div>

              {/* CARD DETAILS WRAPPER */}
              <div style={{ padding: '28px', textAlign: 'left' }}>
                <h3 style={{ 
                  color: isHovered ? '#16803d' : '#1e293b', 
                  fontSize: '22px', 
                  fontWeight: '700', 
                  margin: '0 0 10px 0',
                  transition: 'color 0.3s'
                }}>
                  {card.title}
                </h3>
                <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6', margin: 0 }}>
                  {card.desc}
                </p>
              </div>
            </div>
          );
        })}
      </div>

    </section>
  );
}

export default OrganicJourney;